import React, { useState } from 'react';
import PageLayout from '../../components/base/PageLayout';
import BrokerIntegrationManager from '../../components/broker/BrokerIntegrationManager';
import ProtectedRoute from '../../components/auth/ProtectedRoute';
import { useAuthContext } from '../../contexts/AuthContext';
// import { cleanupInvalidBrokerDocs } from '../../utils/cleanupInvalidBrokerDocs'; // Removed - file deleted
import { FiTrash2 } from 'react-icons/fi';

const BrokerIntegrationsPage = () => {
  const { userProfile, user } = useAuthContext();
  const [isCleaningUp, setIsCleaningUp] = useState(false);
  
  const handleCleanup = async () => {
    // Cleanup function removed - file deleted
    alert('Cleanup function has been removed. Please use the new cleanup utilities.');
  };

  return (
    <ProtectedRoute>
      <PageLayout>
        <div className="max-w-6xl mx-auto p-6">
          <div className="mb-8">
            <div className="flex justify-between items-start">
              <div>
                <h1 className="text-3xl font-bold text-white mb-2">Broker Integrations</h1>
                <p className="text-gray-400">
                  Connect your trading accounts to start automated trading. Your credentials are securely encrypted.
                </p>
              </div>
              {/* Cleanup button - only visible in development */}
              {process.env.NODE_ENV === 'development' && (
                <button
                  onClick={handleCleanup}
                  disabled={isCleaningUp}
                  className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg flex items-center gap-2 transition-colors disabled:opacity-50"
                >
                  <FiTrash2 className="w-4 h-4" />
                  {isCleaningUp ? 'Cleaning...' : 'Clean Duplicates'}
                </button>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
            {/* User Info Card */}
            <div className="bg-gray-900 rounded-lg p-6">
              <h3 className="text-lg font-medium text-white mb-4">Account Info</h3>
              <div className="space-y-2">
                <div>
                  <span className="text-gray-400 text-sm">Username:</span>
                  <p className="text-white font-medium">{userProfile?.username || 'N/A'}</p>
                </div>
                <div>
                  <span className="text-gray-400 text-sm">Email:</span>
                  <p className="text-white font-medium">{userProfile?.email || 'N/A'}</p>
                </div>
                <div>
                  <span className="text-gray-400 text-sm">Subscription:</span>
                  <p className="text-white font-medium capitalize">
                    {userProfile?.subscription?.plan || 'Free'}
                  </p>
                </div>
              </div>
            </div>

            {/* Security Notice */}
            <div className="lg:col-span-2 bg-blue-500/10 border border-blue-500 rounded-lg p-6">
              <h3 className="text-lg font-medium text-blue-400 mb-2">🔒 Security Notice</h3>
              <ul className="text-blue-300 space-y-1 text-sm">
                <li>• Your API credentials are encrypted before storage</li>
                <li>• We never store your broker account passwords</li>
                <li>• You can revoke access at any time</li>
                <li>• Enable 2FA on your broker accounts for extra security</li>
              </ul>
            </div>
          </div>

          {/* Broker Integration Manager */}
          <BrokerIntegrationManager />

          {/* Instructions */}
          <div className="mt-8 bg-gray-900 rounded-lg p-6">
            <h3 className="text-lg font-medium text-white mb-4">How to Connect Your Broker</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold">
                    1
                  </div>
                  <h4 className="text-white font-medium">Get API Credentials</h4>
                </div>
                <p className="text-gray-400 text-sm ml-11">
                  Log into your broker account and generate API keys from the settings or developer section.
                </p>
              </div>
              
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold">
                    2
                  </div>
                  <h4 className="text-white font-medium">Add Integration</h4>
                </div>
                <p className="text-gray-400 text-sm ml-11">
                  Click "Add Broker" above and enter your API credentials. Choose between live or paper trading.
                </p>
              </div>
              
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center text-white font-bold">
                    3
                  </div>
                  <h4 className="text-white font-medium">Verify Connection</h4>
                </div>
                <p className="text-gray-400 text-sm ml-11">
                  Click the verify button to test your connection. Once verified, you're ready to trade!
                </p>
              </div>
            </div>
          </div>

          {/* Supported Brokers */}
          <div className="mt-8 bg-gray-900 rounded-lg p-6">
            <h3 className="text-lg font-medium text-white mb-4">Supported Brokers</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { name: 'Tradier', status: 'Available' },
                { name: 'Tastytrade', status: 'Available' },
                { name: 'Charles Schwab', status: 'Available' },
                { name: 'Interactive Brokers', status: 'Coming Soon' }
              ].map((broker) => (
                <div key={broker.name} className="p-3 bg-gray-800 rounded-lg">
                  <p className="text-white font-medium">{broker.name}</p>
                  <p className={`text-sm ${
                    broker.status === 'Available' 
                      ? 'text-green-400' 
                      : broker.status === 'Coming Soon'
                      ? 'text-yellow-400'
                      : 'text-gray-400'
                  }`}>
                    {broker.status}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </PageLayout>
    </ProtectedRoute>
  );
};

export default BrokerIntegrationsPage; 